import React from "react";

const TaContext = React.createContext({});

export const TaProvider = TaContext.Provider;
export const TaConsumer = TaContext.Consumer;

export default TaContext;
